import { Navigate, useParams } from 'react-router-dom'

interface ActivationRedirectProps {
  to: string
}

export function TokenRedirect(props: ActivationRedirectProps) {
  const { token } = useParams()
  const { to } = props;
  const toStr = to.replace(':token', token || '')

  return <Navigate to={toStr} />
}